import { isNaN, isNil, maxBy } from 'lodash'
import { SANDRE } from '../referencial/constants/ReferencialConstants'

// au-delà de ces bornes, la référence n'est pas un décalage de fuseau.
const MIN_OFFSET_HOURS = -12
const MAX_OFFSET_HOURS = 14

const getOffsetFromTempRef = (tempRef, sandreCodes = []) => {
    const offsetHours = parseInt(sandreCodes.find(sc => sc.field === SANDRE.REF_TEMPORELLES && sc.code === tempRef)?.reference)
    if (isNaN(offsetHours) || offsetHours < MIN_OFFSET_HOURS || offsetHours > MAX_OFFSET_HOURS) {
        return undefined
    }
    return offsetHours
}

// Décalage (GMT+X) dans lequel restituer les mesures d'une station, d'après ses références
// temporelles. sandreCodes porte l'offset dans reference, filtré ou non sur REF_TEMPORELLES.
// undefined => aucune référence exploitable, on retombe sur le fuseau du navigateur.
const getMeasureTempRef = (tempRefs = [], dataType, sandreCodes = []) => {
    const specific = tempRefs.filter(tr => !isNil(tr.typeId) && tr.typeId === dataType)
    const applicable = specific.length ? specific : tempRefs.filter(tr => isNil(tr.typeId))
    // Plusieurs références sur une station = on retient la dernière posée.
    const lastRef = maxBy(applicable, tr => tr.startDate ?? 0)
    if (isNil(lastRef)) {
        return undefined
    }
    return getOffsetFromTempRef(lastRef.tempRef, sandreCodes)
}

const getMeasuresTempRef = (tempRefs = [], dataTypes = [], sandreCodes = []) =>
    dataTypes.map(dataType => getMeasureTempRef(tempRefs, dataType, sandreCodes)).find(offsetHours => !isNil(offsetHours))

// Écarte les références sans décalage exploitable, dont l'heure légale : à passage automatique
// été/hiver, elle ne correspond pas à un fuseau fixe et ne peut pas être proposée à l'affichage.
const getSelectableTempRefs = (sandreCodes = []) => sandreCodes.filter(sc => !isNil(getOffsetFromTempRef(sc.code, sandreCodes)))

const getGmtLabel = offsetHours => isNil(offsetHours) ? '' : `GMT${offsetHours >= 0 ? '+' : '-'}${Math.abs(offsetHours)}`

const getGmtSuffix = offsetHours => isNil(offsetHours) ? '' : ` (${getGmtLabel(offsetHours)})`

export { getMeasureTempRef, getMeasuresTempRef, getOffsetFromTempRef, getSelectableTempRefs, getGmtLabel, getGmtSuffix }